'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ClientUserData(userId, userDetails) {
  this.a8v = null;
  this.XV = null;
  this.a8v = userId;
  this.XV = userDetails;
}
export { $c_Lapp_data_ClientUserData as $c_Lapp_data_ClientUserData };
$p = $c_Lapp_data_ClientUserData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ClientUserData;
/** @constructor */
function $h_Lapp_data_ClientUserData() {
}
export { $h_Lapp_data_ClientUserData as $h_Lapp_data_ClientUserData };
$h_Lapp_data_ClientUserData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_ClientUserData)) {
    var x = this.a8v;
    var x$2 = x$0.a8v;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.XV;
      var x$4 = x$0.XV;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "ClientUserData";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8v;
  }
  if ((n === 1)) {
    return this.XV;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "userId";
  }
  if ((n === 1)) {
    return "userDetails";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_ClientUserData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jj)));
}
export { $isArrayOf_Lapp_data_ClientUserData as $isArrayOf_Lapp_data_ClientUserData };
var $d_Lapp_data_ClientUserData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ClientUserData, "app.data.ClientUserData", ({
  jj: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_ClientUserData as $d_Lapp_data_ClientUserData };
//# sourceMappingURL=app.data.-Client-User-Data.js.map
